// import React from 'react'

// const Consulta = props => {
//     return <></>
// }

// export default Consulta

import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { Formik, Form, FieldArray } from "formik";
import Yup, { validaData, periodoData, validaCPF, validaCodigoBarras } from '../../../../util/Validacoes';
import { mostrarToast } from '../../../../components/Toasts'
import { useParams } from "react-router-dom";
import { ModalDuasOpcoes } from '../../../../components/Modais';
import { get, salvar, validar } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'
import { Link, useHistory } from 'react-router-dom'
import { InputPadrao, InputDatePicker, TextArea } from '../../../../components/Inputs'
import { InputUnidadeMedida, InputCor, InputSimNao, InputProduto, InputFornecedor } from '../../../../components/InputsAutoComplete'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import '../../../../assets/css/icones/iconsmind/style.css'
import Atalho from '../../../../util/Atalho'
import { BtnAcao } from '../../../../components/Acoes';
import { useHotkeys, useIsHotkeyPressed } from 'react-hotkeys-hook';
import InputArquivoS3 from '../../../../components/InputArquivoS3'
import { MODULO } from '../../../../util/Enums'
import { toText } from '../../../../util/FuncoesComuns';


const CadastroSaida = (props) => {
    let { id } = useParams()
    const history = useHistory();
    const idProduto = (history.location.state && history.location.state.id_produto) ? history.location.state.id_produto : null

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [errosValidacao, setErrosValidacao] = useState([]); // string[]
    const [showValidacao, setShowValidacao] = useState(false);
    const [modalProcedimentos, setModalProcedimentos] = useState(false)
    const [dataArquivos, setDataArquivos] = useState(null)
    const [formikProcedimentos, setFormikProcedimentos] = useState({})
    const [limparArquivos, setLimparArquivos] = useState(false)

    const [validacao] = useState(Yup.object({
        produto: Yup.string().nullable().required(),
        data: Yup.string().nullable().required(),
        quantidade: Yup.string().nullable().required(),
        responsavel: Yup.string().nullable().test('Responsável', 'Preencha o campo Responsável ou Outro!', function (value) { return this.parent.outro || this.parent.responsavel }),
        outro: Yup.string().nullable().test('Outro', 'Preencha o campo Responsável ou Outro!', function (value) { return this.parent.outro || this.parent.responsavel })
    }).shape({
        codigo_barras: Yup.array()
            .of(
                Yup.object().shape({
                    inicial: Yup.string().test('CPF', 'Código inválido!', function (value) { return validaCPF(this.parent.inicial) }).nullable(),
                    final: Yup.string().test('CPF', 'Código inválido!', function (value) { return validaCPF(this.parent.final) }).nullable(),
                    quantidade: Yup.string().nullable()
                }))
        // .test("validaCodigo", "Error", function (value) {

        //         var elemento = document.getElementsByName(`codigo_barras[${value.length -1 }].final`);
        //         console.log('ELEMENTO ', elemento)
        //         var isFocused = (document.activeElement === elemento);
        //         console.log('FOCUESED ', focused)
        //         const message = validaCodigoBarras(value);
        //         message && mostrarToast('erro', 'Código Repetido')
        //         return !message;
        //     })
        //     const message = validaCodigoBarras(value);
        //     return !message;
        //   })
    }))

    const validar = (values, propsFormik) => {
        setSalvando(true)
        Promise.resolve(get(`/estoque/validarprodutosaida`, values, true)).then((val) => {
            const lista = Array.isArray(val) ? val : (val?.data ?? val?.result ?? []);
            const erros = (Array.isArray(lista) ? lista : [lista])
                .map((x) => (typeof x === "string" ? x : JSON.stringify(x)))
                .filter(Boolean);

            if (erros.length) {
                setErrosValidacao(erros);
                setShowValidacao(true);
            } else {
                const newFormik = { ...propsFormik, values: { ...values } };
                Submit(newFormik);
            }
        });
    }

    const Submit = (propsFormik) => {
        setSalvando(true)
        propsFormik.values.arquivo = dataArquivos
        salvar(
            propsFormik.values,
            propsFormik.values.id ? '/estoque/produtoentradasaida' : '/estoque/produtosaida',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (salvarENovo) {
                    setLimparArquivos(true)
                    setDataArquivos([])
                    propsFormik.resetForm({})
                    setSalvando(false)
                    setSalvarENovo(false)
                    setLimparArquivos(false)
                }
                else
                    props.history.push('/estoque/produtoentradasaida/consulta')
            },
            (e) => {
                setSalvando(false)
            })

    }

    useEffect(() => {
        if (id) {
            Promise.resolve(get(`/estoque/produtoentradasaida/${id}`)).then(val => {
                if (!val)
                    props.history.push('/estoque/produtoentradasaida/consulta')

                if (val && val.arquivo) {
                    let valorInicial = { ...val }
                    delete valorInicial.arquivo
                    setDataArquivos(val.arquivo)
                }
                setValoresIniciais(val)
            })
        } else {
            setDataArquivos([])
            let valorInicial = {
                produto: null,
                data: null,
                responsavel: null,
                quantidade: null,
                outro: null,
                observacao: null,
                codigo_barras: [{ inicial: undefined, final: undefined, quantidade: undefined }]
            }
            if (idProduto)
                Promise.resolve(get(`/estoque/produto/${idProduto}`)).then(val => {
                    if (val.id)
                        valorInicial.produto = { value: val.id, codigo_barras: val.codigo_barras, label: val.id + ' - ' + val.descricao, bloco: val.bloco }

                    setValoresIniciais(valorInicial)
                    document.getElementById("data").focus();
                })
            else
                setValoresIniciais(valorInicial)
        }
    }, [id])

    return (<Formik
        initialValues={valoresIniciais}
        validationSchema={validacao}
        enableReinitialize={true}
        onSubmit={validar}>
        {propsFormik => (<Form>
            <div className={props.modal ? '' : 'card mb-20'}>
                <div className={props.modal ? '' : 'card-body'}>
                    <div className='row'>
                        <InputPadrao label="Id" name="id" type="hidden" placeholder="Id" obrigatorio={true} />

                        <InputProduto label="Produto" openMenuOnFocus={true} name="produto" placeholder="Produto" propsFormik={propsFormik} obrigatorio={true} tamanho='col-lg-4 col-md-7'
                            salvarENovo={salvarENovo} autoFocus={!id} />

                        <InputDatePicker label="Data Saída" name="data" type="text" id='data' setarValor={value => { propsFormik.setFieldValue("data", value) }}
                            placeholder="Data Saída" classeTooltip={props.modal && 'tooltip-input-modal'} tamanho='col-lg-2 col-md-5' obrigatorio={true} />

                        <InputPadrao label="Quantidade" name="quantidade" type="number" placeholder="Quantidade" tamanho="col-lg-2 col-md-5" obrigatorio={true} />

                        <InputFornecedor label="Responsável" name="responsavel" placeholder="Responsável" propsFormik={propsFormik} tamanho='col-lg-4 col-md-7'
                            salvarENovo={salvarENovo} />

                        <InputPadrao label="Outro" name="outro" type="text" placeholder="Outro" tamanho="col-xl-6 col-lg-6 col-md-12" />

                        <TextArea label='Observação' name='observacao' type='text' placeholder='Observação' tamanho='col-xl-6 col-lg-6 col-md-12' />

                        {dataArquivos != null ?
                            <InputArquivoS3
                                label='Arquivos'
                                name='arquivo'
                                placeholder='Arquivos'
                                tamanho='col-lg-12'
                                diretorioS3='produtoentrada/DDMMYYYY/'
                                modulo={MODULO["/estoque/produtoentradasaida"]}
                                tamanhoMinimo={0}
                                tamanhoMaximoEmMB={300}

                                setDataArquivos={setDataArquivos}
                                dataArquivos={dataArquivos != null ? dataArquivos : []}
                                setIsSubmit={dataArquivos.length > 0 ? setSalvando : () => { }}
                                // setDataArquivos={setDataArquivos}
                                // dataArquivos={dataArquivos != null ? dataArquivos : []}
                                // setIsSubmit={setSalvando}
                                limparCampos={limparArquivos}
                            /> : <></>}

                        {propsFormik.values.produto && propsFormik.values.produto.bloco &&
                            // <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 bt-cinza'>
                            <CadastroSocioEstabelecimentoPlantao formikCadastro={propsFormik}
                                abrirModal={modalProcedimentos} setAbrirModal={setModalProcedimentos} formikProcedimentos={(formik) => setFormikProcedimentos(formik)} />
                            // </div>
                        }

                        <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                    </div>
                </div>
            </div>
            <div className='separator mt-40 mb-5'></div>
            <div className='direita container-botoes mb-3 group-salvar-novo'>
                <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                {!id && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
            </div>
            <ModalDuasOpcoes
                showModal={showValidacao}
                setShowModal={setShowValidacao}
                funcaoOpcao2={_ => { Submit(propsFormik); setShowValidacao(false) }}
                funcaoOpcao1={_ => { setSalvando(false); setShowValidacao(false) }}
                esconderFechar
                mensagem={''}
                textoOpcao1="Cancelar"
                classeOpcao1="btn-sm btn-primary-modal simples"
                textoOpcao2="Continuar"
            >
                <>
                    {errosValidacao.map((t, i) => (
                        <div key={i} style={{ marginBottom: 12, whiteSpace: "pre-line" }}>
                            {t}
                        </div>
                    ))}
                    <b>Deseja Continuar?</b>
                </>
            </ModalDuasOpcoes>
        </Form>)}
    </Formik>);
}

const CadastroSocioEstabelecimentoPlantao = (props) => {

    const [pressedShortcut, setPressedShortCut] = useState(false)
    const [linhaAdicionada, setLinhaAdicionada] = useState(null)

    const calculaQuantidade = (propsFormik, index) => {

        let codigoBarrasInicial = propsFormik.values.codigo_barras[index].inicial
        let codigoBarrasFinal = propsFormik.values.codigo_barras[index].final
        codigoBarrasInicial = parseInt(codigoBarrasInicial.toString().split('-')[0].replace(/\D/g, ''))
        codigoBarrasFinal = parseInt(codigoBarrasFinal.toString().split('-')[0].replace(/\D/g, ''))
        let quantidade = (codigoBarrasFinal - codigoBarrasInicial) + 1
        return propsFormik.setFieldValue(`codigo_barras[${index}].quantidade`, quantidade);

    }

    useHotkeys('tab', () => {
        setPressedShortCut(true)
    }, { enableOnTags: ['INPUT', 'TEXTAREA'] })

    setTimeout(() => setPressedShortCut(false), 500)//SOLUÇÃO TEMPORÁRIA

    const adicionarLinha = async (arrayHelpers, propsFormik, index, button) => {

        let verificador = propsFormik.values.codigo_barras ? propsFormik.values.codigo_barras.filter(x => (x.inicial && x.inicial.length !== 14 && x.final && x.final.length !== 14) || !x.inicial || !x.final) : 'tetega'
        let interposicaoCodigoBarras
        let validacao
        if (verificador.length > 0)
            validacao = true
        else {
            validacao = false
            interposicaoCodigoBarras = await validaCodigoBarras(propsFormik.values.codigo_barras, index, propsFormik.values.id)
        }

        if (validacao)
            mostrarToast('erro', 'Preencha os campos de código de barras inicial e final para adicionar.')
        if ((!propsFormik.errors.codigo_barras && !validacao && !interposicaoCodigoBarras && !propsFormik.values.codigo_barras[index + 1] && pressedShortcut) || (button && !validacao && !interposicaoCodigoBarras)) {
            arrayHelpers.insert(propsFormik.values.codigo_barras.length, { inicial: undefined, final: undefined, quantidade: undefined })
            if (index >= 0) {
                let arrayLinhas = document.getElementsByClassName(`to-focus`)
                if (arrayLinhas)
                    arrayLinhas[arrayLinhas.length - 1].focus()
            }
            setLinhaAdicionada(index)
        }
    }

    const removerLinha = async (arrayHelpers, propsFormik, index) => {
        const arrayCodigoBarras = propsFormik.values.codigo_barras;
        if (arrayCodigoBarras.length === 1) {
            propsFormik.setFieldValue('codigo_barras', [{ inicial: undefined, final: undefined, quantidade: undefined }])
        } else {
            if ((!arrayCodigoBarras[index].inicial || !arrayCodigoBarras[index].final && arrayCodigoBarras.length > 1) || (arrayCodigoBarras[index].inicial || !arrayCodigoBarras[index].final))
                await arrayHelpers.remove(index)
            if (arrayCodigoBarras.length === 1 && (arrayCodigoBarras[index].inicial || arrayCodigoBarras[index].final)) {
                await arrayHelpers.insert(propsFormik.values.codigo_barras.length, { inicial: undefined, final: undefined, quantidade: undefined })
            }
        }
    }

    return (
        <>
            <div className='col-12 bt-cinza'>
                <h3 className='mt-20 mb-20'><span>{'Entrega de Blocos'}</span></h3>
                <div className="mt-2">
                    <div className="custom-scrollbar">
                        <FieldArray name="codigo_barras">
                            {(arrayHelpers => (
                                <>
                                    {// {props.formikCadastro.values.produto && props.formikCadastro.values.socio.length > 0 ?
                                        props.formikCadastro.values && props.formikCadastro.values.codigo_barras && props.formikCadastro.values.codigo_barras.map((item, index) =>
                                            <div className='modal-body-cadastro row mr-0 ml-0'>
                                                {/* <InputPadrao label='Id' name='id' type='hidden' /> */}
                                                <span className={'ajusta-index'}>{index + 1}</span>
                                                <InputPadrao label="Codigo de Barras Inicial" mascara="111.111.111-11" obrigatorio={true} onBlur={() => props.formikCadastro.values.codigo_barras[index].inicial && props.formikCadastro.values.codigo_barras[index].final && (calculaQuantidade(props.formikCadastro, index))} name={`codigo_barras[${index}].inicial`} type="text" placeholder="Codigo de Barras Inicial" tamanho={'col-4 col-sm-12 col-xl-4 col-lg-4 col-md-4 pl-0'} id={'codigo_barras_inicial'} className={'to-focus'} />
                                                <InputPadrao label="Codigo de Barras Final" mascara="111.111.111-11" obrigatorio={true} onBlur={() => props.formikCadastro.values.codigo_barras[index].inicial && props.formikCadastro.values.codigo_barras[index].final && (calculaQuantidade(props.formikCadastro, index), adicionarLinha(arrayHelpers, props.formikCadastro, index, false), setLinhaAdicionada(null))} name={`codigo_barras[${index}].final`} type="text" placeholder="Codigo de Barras Final" tamanho={'col-sm-12 col-xl-4 col-lg-4 col-md-4 pl-0'} id={'codigo_barras_final'} />
                                                <InputPadrao label="Quantidade Folha" obrigatorio={true} name={`codigo_barras[${index}].quantidade`} type="number" placeholder="Quantidade Folha" tamanho={'col-2 col-sm-2 col-xl-2 col-lg-2 col-md-2 pl-0'} id={'codigo_barras_inicial'} />

                                                <div className='col-1 col-xl-1 col-lg-1 col-md-1 mb-0 pr-0 pl-1 pb-3 content-bottom-center flex-end'>
                                                    <BtnAcao type={'button'} icone="icon-Add" texto="Adicionar" action={() => adicionarLinha(arrayHelpers, props.formikCadastro, index, true)} />
                                                    <BtnAcao type={'button'} icone="icon-New-Trash" texto="Remover" action={() => removerLinha(arrayHelpers, props.formikCadastro, index)} />
                                                </div>
                                            </div>
                                        )}
                                </>
                            ))}
                        </FieldArray>
                    </div>
                </div>
            </div>
        </>)
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <Link to={'#'}>Estoque</Link>,
        () => <Link className="link-active" to={'/estoque/produtoentradasaida/consulta'}>Entrada/Saída de Produto</Link>,
    ]
    return (<>
        <HeaderCadastro titulo={"Cadastro Saída de Produto"} link={links} />
        <CadastroSaida {...props} />
    </>
    )
}
export { CadastroSaida }
export default Cadastro
